import { gql } from '@apollo/client';

export default gql`
  query UserByUsernameQuery($username: String!) {
    user: userByUsername(username: $username) {
      id
    }
  }
`;
